import { Injectable } from '@angular/core';

@Injectable()
export class ErrorHandlerService {

    constructor() {
    }

    handle(error) {
        console.log(error);
        alert(error.error.message || error.error || error);
    }
}
